import React from 'react'
import clsx from 'clsx'

import PlayListItem from './PlayListItem/PlayListItem'
import { PlaylistPlay } from "styled-icons/material";

const playList = ({
    currentEpisode,
    playlist,
    setEpisode,
    dragStartHandler,
    dragEndHandler,
    dragOverHandler,
    classes,
    dropDownTrigger
}) => (
        <div className={clsx(
            "playlist-wrapper", {
            [classes]: !!classes
        })}>
            <ul
                id={dropDownTrigger}
                className='dropdown-content'
            >
                <li className="playlist-title"><h3>A seguir</h3></li>
                {
                    playlist.map(episode => (
                        <PlayListItem
                            key={episode.id}
                            episode={episode}
                            active={episode.id === currentEpisode.id}
                            setEpisode={setEpisode}
                            dragStartHandler={dragStartHandler}
                            dragEndHandler={dragEndHandler}
                            dragOverHandler={dragOverHandler}
                        />
                    ))
                }
            </ul>
            <a
                className="dropdown-trigger"
                data-target={dropDownTrigger}
            >
                <PlaylistPlay
                    className="playlist-icon"
                />
            </a>
        </div>
    )

export default playList
